import { axiosAuthInstance } from "../../../config/axios-config";

var InvoiceReceiptTemplatesService = {
  getTemplates: async function (input) {
    return await axiosAuthInstance
      .get("/templates", { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  getTemplatesByID: async function (id) {
    return await axiosAuthInstance.get(`/templates/${id}`).then((res) => {
      return res.data;
    });
  },
  updateTemplate: async function (input) {
    return await axiosAuthInstance
      .put(`/templates`, { ...input })
      .then((res) => {
        return res.data;
      });
  },
};

export default InvoiceReceiptTemplatesService;
